import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faChartBar,
  faLaptopCode,
  faLink,
  faMobileAlt,
  faScrewdriverWrench,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import servicesData from "../../JsonFiles/Services.json";
import "./Services.css";

const ICONS = {
  faLaptopCode,
  faMobileAlt,
  faLink,
  faSearch,
  faChartBar,
  faScrewdriverWrench,
};

const ScrollLink = ({ to, children, ...props }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </RouterLink>
  );
};

const Services = ({ id = "services" }) => {
  const displayedServices = servicesData.slice(0, 6);

  return (
    <section
      id={id}
      className="services-section"
      aria-labelledby="services-title"
    >
      <div className="services-section__decoration" aria-hidden="true" />

      <div className="services-section__container">
        <header className="services-section__header">
          <div className="services-section__heading-group">
            <p className="services-section__eyebrow">
              <span aria-hidden="true" />
              Our expertise
            </p>

            <h2 id="services-title" className="services-section__title">
              Digital solutions designed around
              <span> your business.</span>
            </h2>
          </div>

          <div className="services-section__intro">
            <p>
              We combine product strategy, thoughtful design, and dependable
              engineering to build technology that solves real operational
              challenges and supports long-term growth.
            </p>

            <ScrollLink className="services-section__all-link" to="/services">
              Explore all services
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </ScrollLink>
          </div>
        </header>

        <div className="services-section__grid">
          {displayedServices.map((service, index) => {
            const icon = ICONS[service.icon] ?? faScrewdriverWrench;

            return (
              <article key={service.id} className="services-section__card">
                <ScrollLink
                  className="services-section__card-link"
                  to={`/services/${service.id}`}
                  aria-label={`Learn more about ${service.title}`}
                >
                  <div className="services-section__card-top">
                    <span className="services-section__icon" aria-hidden="true">
                      <FontAwesomeIcon icon={icon} />
                    </span>
                    <span
                      className="services-section__number"
                      aria-hidden="true"
                    >
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <div className="services-section__card-content">
                    <h3>{service.title}</h3>
                    <p>{service.descriptionsmall}</p>
                  </div>

                  <span className="services-section__card-action">
                    Explore service
                    <span
                      className="services-section__arrow"
                      aria-hidden="true"
                    >
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </span>
                </ScrollLink>
              </article>
            );
          })}
        </div>

        <aside
          className="services-section__cta"
          aria-label="Discuss your project"
        >
          <div>
            <span>Need a tailored solution?</span>
            <p>Tell us what you want to improve, build, or scale.</p>
          </div>

          <ScrollLink className="services-section__cta-link" to="/contact">
            Start a conversation
            <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
          </ScrollLink>
        </aside>
      </div>
    </section>
  );
};

export default Services;
